import React from 'react'
import { v4 as uuid } from 'uuid'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

import './ProgressBar.scss'

/**
 * @import import { ProgressBar } from '@/components/navigation/ProgressBar'
 * @param {object} props
 * @param {number} props.currentPage Active step, starting at 1
 * @param {number} props.totalPages Total number of step circles
 * @param {{ slug: string, label: string }[]} [props.links] Renders each circle as a router Link with a tooltip; the current step's circle uses the complete style
 */
export const ProgressBar = ({ currentPage, totalPages, links }) => {
  // Link to each item in the progress bar
  if (links) {
    return (
      <div className="progress-bar">
        {links.map((link, index) => (
          <div
            className="progress-bar-container"
            data-testid="progress-circle-container"
            key={uuid()}
          >
            <InteractiveTooltip placement="bottom" content={link.label}>
              <Link
                to={link.slug}
                className={classNames('progress-circle', { complete: index === currentPage - 1 })}
                data-testid="progress-circle"
              />
            </InteractiveTooltip>
            {!(index === totalPages - 1) && <div className="progress-line" />}
          </div>
        ))}
      </div>
    )
  }

  // Navigate through steps in a wizard
  return (
    <div className="progress-bar">
      {[...Array(totalPages)].map((_, index) => {
        return (
          <div
            className="progress-bar-container"
            data-testid="progress-circle-container"
            key={uuid()}
          >
            <div
              className={classNames('progress-circle', {
                active: index + 1 === currentPage,
                complete: index + 1 < currentPage,
              })}
              data-testid="progress-circle"
            />
            {!(index === totalPages - 1) && <div className="progress-line" />}
          </div>
        )
      })}
    </div>
  )
}
